module.exports = __webpack_public_path__ + "static/media/notes-icon.a1ce9aa9.svg";